export const TOPSPANDER_CABANG_GET_REQUEST = "TOPSPANDER_CABANG_GET_REQUEST";
export const TOPSPANDER_CABANG_GET_SUCCESS = "TOPSPANDER_CABANG_GET_SUCCESS";
export const TOPSPANDER_CABANG_GET_FAIL = "TOPSPANDER_CABANG_GET_FAIL";
export const TOPSPANDER_CABANG_GET_RESET = "TOPSPANDER_CABANG_GET_RESET";
